export const getUrlWithProtocol = (url: string) => {
  let result = url;

  if (!url.match(/^https?:\/\//i)) {
    result = "http://" + url;
  }

  return result;
};
